import React from 'react';
import { 
    Create, 
    SimpleForm, 
    ReferenceInput,
    SelectInput,
    AutocompleteInput,
    DateInput,
    NumberInput,
    TextInput,
    ArrayInput,
    SimpleFormIterator,
    required
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";

const FEE_HEAD_CHOICES = [
    { id: 'registration_fee', name: 'Registration Fee' },
    { id: 'study_material_fee', name: 'Study Material Fee' },
    { id: 'deliverable_fee', name: 'Deliverable Fee' },
    { id: 'tech_support_fee', name: 'Tech Support Fee' },
    { id: 'tuition_fee', name: 'Tuition Fee' },
    { id: 'late_fee', name: 'Late Fee' },
];

export const FeePaymentCreate = props => {
    return (
        <React.Fragment>
            <Create label="Record Payment" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />} className="main-form">
                    <ReferenceInput 
                        source="enrollment_id" 
                        reference="student-enrollment"
                        label="Student Enrollment"
                        fullWidth={true}
                        filterToQuery={searchText => ({ 'enrollment_number': searchText })}
                    >
                        <AutocompleteInput 
                            optionText={(record) => `${record.enrollment_number} - ${record.student_name}`}
                            shouldRenderSuggestions={(val) => { return val && val.trim().length >= 2 }}
                            validate={[required()]} 
                        />
                    </ReferenceInput>
                    
                    <DateInput 
                        source="payment_date" 
                        label="Payment Date"
                        fullWidth={true}
                        className="first_inline_input"
                        validate={[required()]}
                        defaultValue={new Date().toISOString().split('T')[0]}
                    />
                    
                    <NumberInput 
                        source="amount" 
                        label="Total Amount"
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[required()]}
                        min={0}
                    />
                    
                    <SelectInput 
                        source="payment_type" 
                        label="Payment Type" 
                        choices={[
                            { id: 'installment', name: 'Installment' },
                            { id: 'specific_head', name: 'Specific Fee Head' },
                            { id: 'advance', name: 'Advance' },
                            { id: 'miscellaneous', name: 'Miscellaneous' },
                        ]} 
                        validate={[required()]}
                        defaultValue="installment"
                        fullWidth={true}
                        className="first_inline_input"
                        helperText="Select 'Specific Fee Head' to specify which fee components this payment covers"
                    />
                    
                    <SelectInput 
                        source="payment_mode" 
                        label="Payment Mode" 
                        choices={[
                            { id: 'cash', name: 'Cash' },
                            { id: 'cheque', name: 'Cheque' },
                            { id: 'online', name: 'Online' },
                            { id: 'upi', name: 'UPI' },
                            { id: 'card', name: 'Card' },
                        ]} 
                        validate={[required()]}
                        defaultValue="cash"
                        fullWidth={true}
                        className="last_inline_input"
                    />
                    
                    <TextInput 
                        source="transaction_reference" 
                        label="Transaction Reference"
                        fullWidth={true}
                        helperText="For cheque, online, UPI, or card payments"
                    />
                    
                    <TextInput 
                        source="remarks" 
                        label="Remarks"
                        fullWidth={true}
                        multiline
                        rows={3}
                    />

                    <ArrayInput 
                        source="fee_heads" 
                        label="Fee Head Breakdown (optional — leave empty to record full amount as Tuition Fee)"
                    >
                        <SimpleFormIterator inline>
                            <SelectInput 
                                source="fee_head" 
                                label="Fee Head" 
                                choices={FEE_HEAD_CHOICES}
                                validate={[required()]}
                            />
                            <NumberInput 
                                source="amount" 
                                label="Amount" 
                                validate={[required()]}
                                min={0}
                            />
                        </SimpleFormIterator>
                    </ArrayInput>
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
}
